import { EMPTY_STRING } from 'constants/MeshbotConstant';

/**
 * Returns the selected action (state token) of an isUserLockOperation trigger, read straight from Redux
 * (capabilityDynamicFields; shared by all value types of this method). No local state.
 * @param {Object} ruleTrigger - trigger from the store
 * @returns {string}
 */
export const getUserLockOperationState = (ruleTrigger) => {
    return ruleTrigger?.capabilityDynamicFields?.stateFieldValue || EMPTY_STRING;
};
